module.exports = __webpack_public_path__ + "img/0.cb2bd0ad.jpg";